import { render, staticRenderFns } from "./PowerImitateContent.vue?vue&type=template&id=57c20e66&scoped=true"
import script from "./PowerImitateContent.vue?vue&type=script&lang=js"
export * from "./PowerImitateContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c20e66",
  null
  
)

export default component.exports